<template>
   <nuxt-link class="grid-item" :to="localePath('/'+source+'/'+item.id)">
        <div class="base-img">
            <!-- <div class="el-image__placeholder"></div> -->
            <el-image :src="item.bgImage" class="has-backstop image" :alt="item.title">
                <template #error>
                    <div class="no-pic">
                        <img src="@/assets/images/iconSvg/logo_no_pic.svg" alt="item.title">
                    </div>
                </template>
            </el-image>
        </div>
        <div class="news-item-content">
            <!-- 时间字段：原生解析item.showTime -->
            <div class="news-date">
                <span class="date-day">{{ item.showTime?getDay(item.showTime):'' }}</span>
                <span class="date-month">{{ item.showTime?getMonthYear(item.showTime):'' }}</span>
            </div>
            <div class="news-item-title two-text-flow">{{ item.title }}</div>
            <div class="news-item-desc two-text-flow">
                {{ item.subTitle }}
            </div>
        </div>
    </nuxt-link>
</template>
<script lang="ts" setup>
import { getDay,getMonthYear } from "@/utils/utils";
import { ArrowRight,Picture } from '@element-plus/icons-vue'
import type { NewsItem } from '@/types';
import { useLocalePath,useRuntimeConfig} from '#imports';
const localePath = useLocalePath()
const props = withDefaults(
    defineProps<{
        item: NewsItem,
        source:string,
    }>(),
    {
        item: () => ({
            bgImage: '',
            title: '',
            content: '',
            subTitle:'',
            showTime: ''
        }),
        source:'news'
    }
);
</script>
<style scoped lang="scss"> 
    .grid-item {
        overflow: hidden;
        color: #fff;
        line-height:26px;
        font-size: 16px;
        .news-item-content{
            background:#242C3E;
            padding:var(--spacing-24);
            height:232px;
        }
        .base-img{
            padding-bottom:57%;
        }
        .image{
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            //  height: 236px; // PC端图片高度
            background:#000;
            :deep(img){
                width: 100%;
                height:auto;
                height: 100%;
                // max-height: 236px; // PC端图片高度
                object-fit: cover; // 保持图片比例
                transition: transform 1s; /* 平滑过渡效果 */
            }
            .image-slot {
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                font-size: 30px;
                height:100%;
            }
        }
        .news-date {
            display: flex;
            align-items: baseline;
            gap: 8px;
            margin-bottom: var(--spacing-12);
            font-size: 14px;
            .date-day {
                font-size: 40px;
                font-weight: 600;
                line-height: 1; // 消除数字上下留白
            }
            .date-month {
                opacity:0.5;
            }
        }
        .news-item-title{
            margin: 0 0 var(--spacing-12);
            line-height:26px;
            word-break: break-word;
            transition: all .3s;
            a{
                color:#fff;
                &:hover{
                     color:var(--org-color);
                }
            }
        }
        .news-item-desc {
            padding: var(--spacing-12) 0 var(--spacint-24);
            margin: 0;
            opacity:0.5;
            a {
                color:#fff;
                opacity: 0.5;
            }
        
        }
        &:hover {
            :deep(.image img) {
                transform: scale(1.05);
            }
            .news-item-title{
                color: var(--org-color);
            }
        }
        
        
    }
    @media (max-width: 767px) {
        .grid-item{
            font-size: 14px;
            .news-item-content{
                padding:var(--spacing-16);
            }
            .news-date{
                .date-day {
                    font-size:32px;
                }
            }
        }
    }
    @media (max-width: 480px) {
        .grid-item{
            .news-item-content{
                height:auto;
                padding:var(--spacing-12);
            }
            .news-date{
                margin-bottom:0;
            }
        }
    }
</style>